import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useUpdatePaymentMethodAvailability = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const updateAvailability = async (payload) => {
		const instance = await InitApi({ accessToken });
		const response = await instance.put("/payment-methods/availability", payload);
		return response.data;
	};

	return useMutation(updateAvailability, {
		onSuccess: async (data) => {
			await queryClient.invalidateQueries("payment-method-availability");
			toast.success(data.message || "Payment method availability updated");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.errors || error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				},
			);
		},
	});
};

export default useUpdatePaymentMethodAvailability;
